export default __webpack_public_path__ + "static/media/booking-app-pic1.7c43a1a5.png";